(() => {
  function initialize(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const science = root.querySelector('.sb-science-figure');
    const explanation = root.querySelector('.sb-explanation .sb-copy');
    if (science && explanation) {
      const desktopParent = science.parentElement;
      const mobile = window.matchMedia('(max-width: 640px)');
      const placeScience = () => {
        if (mobile.matches) explanation.insertBefore(science, explanation.querySelector('p:last-of-type'));
        else desktopParent.appendChild(science);
      };
      mobile.addEventListener('change', placeScience);
      placeScience();
    }

    const cards = [...root.querySelectorAll('[data-testimonial]')];
    const counter = root.querySelector('[data-counter]');
    let selected = 0;
    root.querySelectorAll('[data-carousel-step]').forEach(button => {
      button.addEventListener('click', () => {
        selected = (selected + Number(button.dataset.carouselStep) + cards.length) % cards.length;
        cards.forEach((card, index) => { card.hidden = index !== selected; });
        counter.textContent = `${selected + 1} / ${cards.length}`;
      });
    });
  }
  document.querySelectorAll('.sb-page').forEach(initialize);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('.sb-page').forEach(initialize);
  });
})();
